import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';

export const workTypeMetricDetailEntryPoint = createPageEntryPoint({
	main: {
		root: JSResourceForInteraction(
			() =>
				import(
					/* webpackChunkName: "async-system-performance-metric-detail", jiraSpaEntry: "async-system-performance-work-type" */ '@atlassian/jira-spa-apps-admin-pages-performance-work-type'
				),
		),
		getPreloadProps: () => ({}),
	},
	topNavigationMenuId: MENU_ID.SETTINGS,
});
